<template>
    <section>
      <div class="container container-app pr-0 pl-0" style="width: 100%;max-width: 100%;">
            <section class="position-relative">
                <div v-if="searchInput" class="row mt-3 pb-3 header-container">
                    <!-- in case search is reverted to old format <div class="col-12">
                        <button type="button" class="close" aria-label="Close">
                            <img @click.prevent="toggleSearchInput(); resetSearch();" src="./../../assets/ics.svg" alt="ics" />
                        </button>
                        <div class="input-group">
                            <input type="text" class="form-control form-control--canvassing border-bottom"  aria-label="Recipient's username" aria-describedby="basic-addon2" v-model="form.text">
                            <div @click.prevent="search(header_page_data.search.type_search)" class="input-group-append">
                                <span class="input-group-text input-group-text--canvassing" id="basic-addon2"><img class="float-right pr-2" src="./../../assets/search.svg" alt="search" /></span>
                            </div>
                        </div>
                    </div> -->
                </div>
                <div v-else class="row mt-3 pb-3 header-container">
                    <div class="col-2 header-left-region">
                        <img @click.prevent="goto(typeof header_page_data.home.goto != 'undefined' ? header_page_data.home.goto : 'home', typeof header_page_data.home.goto != 'undefined' ? {campaign_id: $route.params.campaign_id} : {})" v-if="header_page_data.home.show" class="float-left pr-2  ml-3 cursor-pointer mt-1" src="./../../assets/home.svg" alt="home" />
                        <img class="red-dot-position" v-if="isNewAlerts && header_page_data.profile.show" src="./../../assets/red_dot.svg" alt="ALERTS" /><img @click.prevent="goto('profile')" v-if="header_page_data.profile.show" class="float-left pr-2  ml-3 cursor-pointer mt-1" src="./../../assets/profile.svg" alt="profile" />
                    </div>
                    <div class="col-8 header-center-region text-center">
                        <u v-if="isLink" @click.prevent="linkIfNeeded" class="cursor-pointer">{{ trimText(header_page_data.title) }}</u>
                        <span v-else @click.prevent="linkIfNeeded">{{ trimText(header_page_data.title) }}</span>
                        <img v-if="header_page_data.settings.show && isOwner(header_page_data.settings.campaign.owner_id)"  @click.prevent="goto('campaign-settings', {campaign: header_page_data.settings.campaign})" class="ml-2 cursor-pointer" src="./../../assets/settings.svg" alt="settings" />
                    </div>
                    <div class="col-2 header-right-region">
                        <img @click.prevent="logout" class="float-right mr-3 cursor-pointer mt-1" src="./../../assets/logout.svg" alt="logout" />
                        <!-- in case search is reverted to old format <img v-if="header_page_data.search.show" @click.prevent="toggleSearchInput" class="float-right pr-2 cursor-pointer" src="./../../assets/search.svg" alt="search" /> -->
                    </div>
                </div>
            </section>
      </div>
    </section>
</template>

<script>
    import HelperMixin from "../../mixins/HelperMixin";

    export default {
        name: "Header",
        props: ["header_page_data"],
        mixins: [HelperMixin],
        data() {
            return {
                searchInput: false,
                form: {
                    text: ""
                }
            }
        },
        created() {
            
        },
        computed: {
            isLink() {
                if (
                    this.$route.name == 'add-location' || 
                    this.$route.name == 'campaign-settings' ||
                    this.$route.name == 'edit-location' ||
                    this.$route.name == 'campaign-teams' ||
                    this.$route.name == 'locations-list' ||
                    this.$route.name == 'campaign-locations' ||
                    this.$route.name == 'campaign-reports'
                ) {
                    return true;
                }
                return false;
            },

            isNewAlerts() {
                if(typeof this.$store.getters["alertLastDate"] == 'undefined' && this.$store.getters["alerts"].length > 0) {
                    return true;
                } else if (typeof this.$store.getters["alertLastDate"] == 'undefined' || this.$store.getters["alerts"].length == 0) {
                    return false;
                } else if (this.$store.getters["alertLastDate"] < this.$store.getters["alerts"][0].created_at) {
                    return true;
                }
            },
        },
        methods: {
            linkIfNeeded() {
                if (this.$route.name == 'add-location') {
                    if (typeof this.$store.getters["currentCampaign"]._id != 'undefined') {
                        this.$router.push({ name: 'campaign-map', params: {campaign_id: this.$store.getters["currentCampaign"]._id , campaign: this.$store.getters["currentCampaign"]}});
                    }
                } else if (this.$route.name == 'campaign-settings') {
                    if (typeof this.$store.getters["currentCampaign"]._id != 'undefined') {
                       this.$router.push({ name: 'campaign-map', params: {campaign_id: this.$store.getters["currentCampaign"]._id , campaign: this.$store.getters["currentCampaign"]}});
                    }
                } else if (this.$route.name == 'edit-location') {
                    if (typeof this.$store.getters["currentCampaign"]._id != 'undefined') {
                       this.$router.push({ name: 'campaign-map', params: {campaign_id: this.$store.getters["currentCampaign"]._id , campaign: this.$store.getters["currentCampaign"]}});
                    }
                } else if (this.$route.name == 'campaign-teams') {
                    if (typeof this.$store.getters["currentCampaign"]._id != 'undefined') {
                       this.$router.push({ name: 'campaign-map', params: {campaign_id: this.$store.getters["currentCampaign"]._id , campaign: this.$store.getters["currentCampaign"]}});
                    }
                } else if (this.$route.name == 'locations-list') {
                    if (typeof this.$store.getters["currentCampaign"]._id != 'undefined') {
                       this.$router.push({ name: 'campaign-map', params: {campaign_id: this.$store.getters["currentCampaign"]._id , campaign: this.$store.getters["currentCampaign"]}});
                    }
                } else if (this.$route.name == 'campaign-locations') {
                    if (typeof this.$store.getters["currentCampaign"]._id != 'undefined') {
                       this.$router.push({ name: 'campaign-map', params: {campaign_id: this.$store.getters["currentCampaign"]._id , campaign: this.$store.getters["currentCampaign"]}});
                    }
                } else if (this.$route.name == 'campaign-reports') {
                    if (typeof this.$store.getters["currentCampaign"]._id != 'undefined') {
                       this.$router.push({ name: 'campaign-map', params: {campaign_id: this.$store.getters["currentCampaign"]._id , campaign: this.$store.getters["currentCampaign"]}});
                    }
                }
            },

            resetSearch() {
                this.form.text = "";
                this.search(this.header_page_data.search.type_search);
            },
            
            toggleSearchInput() {
                this.searchInput = !this.searchInput;
            },

            logout() {
                this.$store.dispatch('forceLogout');
                this.$store.dispatch('saveIsLoading', {
                    isLoading: true
                });
                this.$router.replace({ name: "login"});
            },

            search(type) {
                this.$store.dispatch('saveIsLoading', {
                    isLoading: true
                });
                if (type === 'campaigns') {
                    let config = {
                        headers: {
                            'Authorization': `Bearer ${this.$store.getters["token"]}`,
                        }
                    };

                    axios.post(
                            '/api/v1/campaign/search',
                            this.form,
                            config
                    ).then(this.consumeSearchCampaigns, this.errorSearch);
                } else if (type === 'locations') {
                    this.$parent.locations = [];
                    this.$parent.page = 1;
                    this.$parent.search = this.form.text;
                    this.$parent.stopLoad = false;
                    this.$parent.getCampaignLocations(this.$parent.page, this.$parent.search);

                }
            },

            consumeSearchCampaigns: function (response) {
                this.$store.dispatch('saveCampaignsList', {
                    campaignsList: response.data.data
                });

                this.$store.dispatch('saveIsLoading', {
                    isLoading: false
                });
            },

            errorSearch: function (error) {
                this.$store.dispatch('saveIsLoading', {
                    isLoading: false
                });
                console.log(error);
            },
        },
    };
</script>
